exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".oda-control {\n  border-bottom: 1px solid #e9e9e9;\n  border-top: 1px solid #e9e9e9;\n  display: block;\n}\n", ""]);

// exports
